import { useEffect, useState } from 'react';
import { fetchBauordnungBundle } from '../../services/bauordnungService';
import { describeError } from '../../services/errorMessage';
import type { BauordnungKachelLage } from './kachel';

/**
 * Stand der Baustellenordnung EINES Projekts fuer die Hub-Kachel 06
 * (Stufe B4, Muster usePlanungKachel). Liest `fetchBauordnungBundle` und legt
 * wie dieses NICHTS an: die Kachel zeigt den Stand, erzeugt aber keinen
 * Kopfsatz — ein Projekt ohne Baustellenordnung bleibt ohne, bis jemand das
 * Modul oeffnet und sie anlegt.
 *
 * Fail-open: scheitert das Lesen, traegt der Stand `fehler` und kein Buendel.
 * Die Kachel zeigt dann „Stand nicht lesbar" — nie gruen. Eine fehlende
 * Tabelle wirft nicht, sie kommt als `schemaFehlt` im Buendel.
 *
 * `aktiv: false` (Handy, SiFa, Raster-Filter der Handy-App) fragt nichts ab:
 * die Kachel ist dort nicht zu sehen.
 *
 * Der Stand traegt den Schluessel, fuer den er gilt (Muster
 * useModuleActivity): beim Projektwechsel zeigt die Kachel nie den Stand des
 * vorigen Projekts, ohne dass der Effekt synchron zuruecksetzen muesste.
 */

const LADEND: BauordnungKachelLage = { laden: true, bundle: null, fehler: null };
const INAKTIV: BauordnungKachelLage = { laden: false, bundle: null, fehler: null };

export const useBauordnungKachel = (
    projectId: string | null | undefined,
    aktiv: boolean = true,
): BauordnungKachelLage => {
    const schluessel = aktiv && !!projectId && projectId !== 'temp-id' ? projectId : '';
    const [stand, setStand] = useState<{ fuer: string } & BauordnungKachelLage>({ fuer: '', ...LADEND });

    useEffect(() => {
        if (!schluessel) return;
        let abgebrochen = false;
        fetchBauordnungBundle(schluessel)
            .then(bundle => {
                if (!abgebrochen) setStand({ fuer: schluessel, laden: false, bundle, fehler: null });
            })
            .catch((e: unknown) => {
                if (abgebrochen) return;
                console.warn('Stand der Baustellenordnung für die Kachel konnte nicht gelesen werden.', e);
                // describeError: Supabase wirft schlichte Objekte, kein Error.
                setStand({ fuer: schluessel, laden: false, bundle: null, fehler: describeError(e) });
            });
        return () => { abgebrochen = true; };
    }, [schluessel]);

    if (!schluessel) return INAKTIV;
    return stand.fuer === schluessel ? stand : LADEND;
};
